import { attendeeFetchData, attendeeSendData } from "./index";

const sponsorsAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/sponsors`),

  fetchBoothInfo: (attendeeId, sponsor) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/exhibit-hall/${sponsor}`),
  fetchExhibitorMaterials: (attendeeId, sponsor) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/exhibit-hall/${sponsor}/materials`),
  sendInfoToExhibitor: (attendeeId, sponsor, data) => attendeeSendData(`/api/v2/attendees/${attendeeId}/exhibit-hall/${sponsor}/contact-me`, data),
  enterToGiveAway: (attendeeId, sponsor, data) => attendeeSendData(`/api/v2/attendees/${attendeeId}/exhibit-hall/${sponsor}/giveaways/${data.id}/join`, data)
}

export default sponsorsAPI;
